<app-entity-mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle title="Group Lesson">
</app-entity-mat-dialog-title>

<div [ngClass]="{
        'loading-shade': showProgressSpinner
     }">

    <div mat-dialog-content>

        <mat-progress-spinner class="matProgressSpinnerCentered"
            *ngIf="showProgressSpinner" mode="indeterminate">
        </mat-progress-spinner>

        <mat-tab-group class="eventTabGroup" [(selectedIndex)]="this.selectedIndex"
            (selectedTabChange)="setFormMode($event.index);"
            animationDuration="0ms" #tabs>

            <mat-tab label="View" [disabled]="this.initActionType == 'create'">
                <app-entity-mat-tab-view [entityData]="entityData">
                </app-entity-mat-tab-view>
            </mat-tab>

            <mat-tab
                label="{{(this.initActionType == 'create' ? 'Create' : 'Edit')}}">
                <app-error-message [message]=this.errorMessage>
                </app-error-message>

                <!-- Form -->
                <form (ngSubmit)="onSubmit(f)" #f="ngForm" class="form">
                    <div class="container">
                        <div class="row">

                            <div class="col-6">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Lesson Type</mat-label>
                                    <mat-select ngModel name="field_type" (selectionChange)="updateLessonDefaultTimes($event.value, 'group_lesson'); onLessonTypeChange($event.value)">
                                        <mat-option>None</mat-option>
                                        <mat-option
                                            *ngFor="let element of this._taxonomyService.group_lesson_types"
                                            [value]="element.id">{{ element.name }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-6" *ngIf="this.actionType != 'create'">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Instructor</mat-label>
                                    <mat-select matInput ngModel name="field_instructor">
                                        <mat-option>None</mat-option>
                                        <ng-container *ngFor="let element of this._fieldsService.instructorData()">
                                            <mat-option *ngIf="element.status !== '0' || (element.status === '0' && element.uid === field_instructor)"
                                                        [value]="element.uid">
                                                {{ element.value }}
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-6" *ngIf="this.actionType == 'create'">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Instructor</mat-label>
                                    <mat-select matInput multiple ngModel name="field_instructor">
                                        <mat-option>None</mat-option>
                                        <ng-container *ngFor="let element of _fieldsService.instructorData(); let i = index">
                                            <mat-option *ngIf="element.status !== '0' || (element.status === '0' && element.uid === field_instructor)"
                                                        [value]="element.uid">
                                                {{ element.value }}
                                                <ng-container *ngIf="element.status === '0' && element.uid === field_instructor"></ng-container>
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-6">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Duration</mat-label>
                                    <mat-select matInput ngModel
                                        name="field_duration">
                                        <mat-option>None</mat-option>
                                        <mat-option
                                            *ngFor="let element of this._fieldsService.durations"
                                            [value]="element.value">
                                            {{ element.value }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-6">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Choose a date</mat-label>
                                    <input [(ngModel)]="field_date_and_time"
                                           name="field_date_and_time"
                                           matInput
                                           type="text"
                                           appFlatpickrDatetime
                                           [enableTime]="true"
                                           [minuteIncrement]="15"
                                           [setCurrentTimeOnOpen]="true"
                                           [closeOnSelect]="false"
                                           (ngModelChange)="handleDateTimeChange($event)"
                                           required
                                           readonly>
                                    <mat-icon matSuffix>calendar_today</mat-icon>
                                </mat-form-field>
                            </div>

                            <div class="col-12">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Notes</mat-label>
                                    <textarea ngModel name="field_notes"
                                        matInput placeholder=""></textarea>
                                </mat-form-field>
                            </div>



                            <div class="col-12 mt-1">
                                <input
                                    class="d-none"
                                    type="text"
                                    [(ngModel)]="field_student"
                                    name="field_students"
                                    value="{{studentList}}">

                                <div class="pi-card mat-elevation-z1">
                                    <div class="pi-header">
                                        <div>
                                            <div class="pi-title">Attendees</div>
                                            <div class="pi-subtitle">
                                                {{ isNonUnitGroup()
                                                    ? 'Select student account, contact, and Non Unit Group enrollment.'
                                                    : 'Select student account and contact.' }}
                                            </div>
                                        </div>
                                        <div class="pi-meta" *ngIf="objLength(field_student) > 0">
                                            {{ objLength(field_student) }} attending
                                        </div>
                                    </div>

                                    <!-- Attendees list -->
                                    <div class="pi-section" *ngIf="!editMode && objLength(field_student) > 0">
                                        <app-display-attendees
                                            [field_students]="field_student"
                                            [studentUpdateLoad]="studentUpdateLoad"
                                            [studentRemove]="studentRemove"
                                            [editMode]="editMode"></app-display-attendees>
                                    </div>

                                    <!-- Inline attendee form. Group classes take several attendees, so it
                                         stays open after each one is added. -->
                                    <div
                                        class="pi-form attendee-form-card"
                                        ngModelGroup="__field_students_inline_form"
                                        #attendee="ngModelGroup">

                                        <input class="d-none" ngModel name="id" matInput>
                                        <input class="d-none" [ngModel]="entityType" name="type" matInput>
                                        <input class="d-none" [ngModel]="entityBundle" name="bundle" matInput>

                                        <div class="pi-form-grid">
                                            <!-- Student Account Autocomplete -->
                                            <div class="pi-field">
                                                <mat-form-field class="full-width-field">
                                                    <mat-label>Student Account</mat-label>
                                                    <input
                                                        required
                                                        name="field_student_account"
                                                        (input)="onAutocompleteStudent($event)"
                                                        matInput
                                                        [ngModel]="''"
                                                        #td_student_account
                                                        [matAutocomplete]="autoCompleteStudentAccount">
                                                    <button type="button" matSuffix mat-icon-button
                                                        aria-label="manage_accounts">
                                                        <mat-icon>manage_accounts</mat-icon>
                                                    </button>
                                                </mat-form-field>
                                                <mat-autocomplete
                                                    #autoCompleteStudentAccount="matAutocomplete"
                                                    (optionSelected)="lookupStudentAccountContact($event, true, 'group_lesson'); loadNonUnitGroupEnrollments($event);">
                                                    <mat-option
                                                        *ngFor="let option of autoCompleteStudentOptions"
                                                        [value]="option.label + ' (' + option.value + ')'">
                                                        {{option.label}} ({{option.value}})
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </div>

                                            <div class="pi-field" *ngIf="objLength(autoCompleteStudentContactOptions) > 0">
                                                <label class="pi-label">Students<sup>*</sup></label>
                                                <div class="pi-radio-wrap">
                                                    <mat-radio-group
                                                        ngModel
                                                        name="field_students"
                                                        class="radio-group"
                                                        aria-label="Select an option"
                                                        required>
                                                        <mat-radio-button
                                                            class="pi-radio"
                                                            *ngFor="let contact of autoCompleteStudentContactOptions"
                                                            [value]="contact['id']">
                                                            {{ contact['title'] }}
                                                        </mat-radio-button>
                                                    </mat-radio-group>
                                                </div>
                                            </div>

                                            <!-- Enrollment Dropdown: Non Unit Group classes only. Lists the
                                                 student's Non Unit Group enrollments (Non-Unit category,
                                                 lesson type Non Unit Group), as the student dashboard
                                                 filters them. -->
                                            <div class="pi-field" *ngIf="isNonUnitGroup()">
                                                <mat-form-field class="full-width-field">
                                                    <mat-label>Enrollment Name</mat-label>
                                                    <mat-select
                                                        matInput
                                                        ngModel
                                                        name="field_enrollment"
                                                        #enrollment_id>
                                                        <mat-select-trigger>
                                                            <ng-container *ngIf="getEnrollmentById(enrollment_id.value) as selected">
                                                                {{ selected.title[0]?.value }}
                                                                (Avail:
                                                                  <span [ngClass]="getNonUnitZeroClass(selected)">
                                                                    {{ selected.field_lesson_available[0]?.value }}
                                                                  </span>
                                                                  of {{ selected.field_enrollment_lesson_count[0]?.value }},
                                                                Due: {{
                                                                  selected.field_balance_due[0]?.value | studioCurrency
                                                                }})
                                                            </ng-container>
                                                        </mat-select-trigger>
                                                        <mat-option>None</mat-option>
                                                        <mat-option
                                                            *ngFor="let element of enrollmentsForUser"
                                                            [value]="element.id[0].value">
                                                            {{ element.title[0]?.value }}
                                                            (Avail:
                                                              <span [ngClass]="getNonUnitZeroClass(element)">
                                                                {{ element.field_lesson_available[0]?.value }}
                                                              </span>
                                                              of {{ element.field_enrollment_lesson_count[0]?.value }},
                                                            Due: {{
                                                              element.field_balance_due[0]?.value | studioCurrency
                                                            }})
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-hint>
                                                        {{ nonUnitGroupNoEnrollment
                                                            ? 'No Non Unit Group enrollment for this student'
                                                            : 'Non Unit Group enrollments only' }}
                                                    </mat-hint>
                                                </mat-form-field>
                                            </div>

                                            <div class="pi-field">
                                                <mat-form-field class="full-width-field">
                                                    <mat-label>Description</mat-label>
                                                    <textarea
                                                        name="field_description"
                                                        ngModel
                                                        matInput
                                                        placeholder=""></textarea>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <div class="pi-actions">
                                            <button *ngIf="!editMode" type="button"
                                                mat-raised-button
                                                [disabled]="!attendee.valid"
                                                class="me-1"
                                                color="primary" (click)="studentIncrement(attendee.value)">
                                                Add attendee
                                            </button>
                                            <button *ngIf="editMode" type="button"
                                                mat-raised-button
                                                [disabled]="!attendee.valid"
                                                class="me-1"
                                                color="primary" (click)="studentUpdateSubmit(editIndex, attendee.value)">
                                                Edit Attendee
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div class="col-12" *ngIf="this.actionType === 'create'">
                                <app-standing-series
                                  [studentAccountId]="''"
                                  [instructorId]="f?.value?.field_instructor?.[0] || ''"
                                  [duration]="f?.value?.field_duration || '00:45'"
                                  [time]="field_date_and_time ? (field_date_and_time | date:'HH:mm') : ''"
                                  [startDate]="field_date_and_time ? (field_date_and_time | date:'yyyy-MM-dd') : ''"
                                  [lessonType]="f?.value?.field_type || ''"
                                  [bundle]="'group_lesson'"
                                  [selectedEnrollment]="null"
                                  [supportsEnrollment]="false"
                                  [requiresStudent]="false"
                                  [requiresInstructor]="true"
                                  (recurrenceChanged)="onRecurrenceChanged($event)">
                                </app-standing-series>
                                <div class="text-muted small mt-1" *ngIf="isRecurring">
                                    A separate recurring class is created for each selected instructor. Attendees are added per occurrence after generation.
                                </div>
                            </div>


                        </div>
                    </div>
                </form>
            </mat-tab>

            <mat-tab label="Delete"
                [disabled]="this.initActionType == 'create'">
                <app-entity-confirm-delete></app-entity-confirm-delete>
            </mat-tab>

        </mat-tab-group>

    </div>

</div>

<mat-dialog-actions align="end">
    <ng-container *ngIf="this.actionType === 'create'">
        <button type="button"
            [disabled]="isSaving || !isStandingAppointmentValid() || (isRecurring && (!recurrenceConfig || recurrenceConfig.days.length === 0))"
            (click)="onSubmit(f);" mat-raised-button
            color="primary">{{ isRecurring
                                 ? (isSaving ? 'Generating...' : 'Save & Generate Series')
                                 : (isSaving ? 'Saving...' : 'Save') }}</button>
    </ng-container>

    <!-- Conflict display for recurring save (grouped by instructor) -->
    <div *ngIf="seriesConflicts?.length > 0" class="series-conflict-section" style="width: 100%; padding: 12px 0;">
        <div style="display: flex; align-items: center; gap: 8px; color: #c62828; margin-bottom: 8px;">
            <mat-icon>warning</mat-icon>
            <strong>{{ seriesConflicts.length }} conflict(s) found</strong>
        </div>
        <div style="max-height: 120px; overflow-y: auto; margin-bottom: 8px;">
            <div *ngFor="let c of seriesConflicts" style="font-size: 0.9em; padding: 2px 0; color: #555;">
                <strong *ngIf="c.instructor">{{ c.instructor }}</strong><span *ngIf="c.instructor"> &mdash; </span>{{ c.date | date:'EEE, MMM d' }} &mdash; {{ c.message }}
            </div>
        </div>
        <div style="display: flex; gap: 8px;">
            <button mat-raised-button color="warn" [disabled]="isSaving" (click)="generateIgnoringConflicts()">
                Generate Anyway
            </button>
            <button mat-raised-button [disabled]="isSaving" (click)="cancelRecurringSave()">
                Cancel
            </button>
        </div>
    </div>
    <ng-container *ngIf="this.actionType === 'edit'">
        <ng-container *ngIf="this.initActionType == 'edit'">
            <button type="button" [disabled]="isSaving || hasPostedAttendee()" (click)="setFormMode('delete')"
                [matTooltip]="hasPostedAttendee() ? 'A posted attendee is on this class. Unpost first.' : ''"
                mat-raised-button color="accent">Delete</button>
            <button type="button" [disabled]="isSaving" (click)="onSubmit(f);" mat-raised-button
                color="primary">{{ isSaving ? 'Saving...' : 'Save' }}</button>
        </ng-container>
        <ng-container *ngIf="this.initActionType == 'create'">
            <button type="button" (click)="closeDialog()" mat-raised-button
                color="accent">Cancel</button>
            <button type="button" [disabled]="isSaving" (click)="onSubmit(f);" mat-raised-button
                color="primary">{{ isSaving ? 'Saving...' : 'Save' }}</button>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="this.actionType === 'delete'">
        <button (click)="setFormMode('edit')" type="submit" mat-raised-button
            color="accent">Cancel</button>
        <button [disabled]="hasPostedAttendee()"
            (click)="onDeleteSubmit(this._injectedDialogData['data']['EntityID'])"
            type="submit" mat-raised-button color="accent">Delete</button>
    </ng-container>
</mat-dialog-actions>
